import { Signal } from '@lit-labs/preact-signals';

const titleRevision = new Signal<number>(0);

export function pageTitle(getTitle: () => string): () => string {
  return () => {
    // The router's title effect tracks this read and reruns when the locale changes.
    titleRevision.value;
    return getTitle();
  };
}

export function refreshPageTitles(): void {
  titleRevision.value++;
}
